var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightedEventCardTopIllus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 87,
    viewBox: "0 0 162 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0107666 87C93.2275 65.0854 65.9998 29.5 116.5 13C128.572 9.05549 148.5 16.5 161.5 5.84891e-05C143.532 5.02023e-05 13 5.05447e-05 0.00390625 0.000143366C0.00512029 48.5527 0.0105413 11.104 0.0107666 87Z",
    fill: "#FCCE2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedEventCardTopIllus);
export default __webpack_public_path__ + "static/media/highlighted-event-card-top-illus.6f4c726659a7898ff4175589172fb050.svg";
export { ForwardRef as ReactComponent };